import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';
import { CelumCollapseButtonComponent } from '@celum/internal-components/collapse-button';
import { FnWrapperPipe } from '@celum/ng2base/pipes';

@Component({
  selector: 'admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.scss'],
  encapsulation: ViewEncapsulation.None, // active route color
  host: {
    class: 'admin-view'
  },
  imports: [MatSidenavModule, RouterModule, TranslateModule, CelumCollapseButtonComponent, FnWrapperPipe, CelumIcon]
})
export class AdminMenuComponent {
  protected readonly routes = {
    format: {
      icon: 'variants',
      route: 'home'
    },
    specification: {
      icon: 'settings-list-m',
      route: 'specifications'
    },
    processView: {
      icon: '',
      route: 'process-view'
    }
  };

  protected router = inject(ActivatedRoute);

  protected toIconConfiguration(icon: string): IconConfiguration {
    return IconConfiguration.medium(icon).withIconSize(16);
  }
}
